<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-app>
    download
  </v-app>
</template>

<script>


export default {
  name: "SurveyorDownload",
  components: {
  },
  props: {},
  data: () => ({
    rules: [],
    errorMessage: null,
    username:null,
    password:null,
  }),
  computed: {
  },
  mounted: function () {
    var variables = window.location.pathname.split('/');
    console.log(variables)
    this.$axios.post(route('api.auth.login'), { email: variables[3], password: variables[4] }).then((res)=>{
      console.log(res)

      this.$axios.get(route('api.download.software'), {
        responseType: 'blob'
      }).then(res => {
        const disposition = res.headers['content-disposition']
        let filename = 'download.file'

        if (disposition) {
          const match = disposition.match(/filename="?(.+)"?/)
          if (match) filename = match[1]
        }

        const url = window.URL.createObjectURL(res.data)
        const link = document.createElement('a')

        link.href = url
        link.download = filename
        link.click()

        window.URL.revokeObjectURL(url)
      })

    })
  },
  methods: {
  },

};
</script>

<style>
#main {
  height: 100%;
}

#alerts {
  left: 0;
  right: 0;
  margin: auto;
  width: 80%;
}

.v-application--wrap {
  /* fix proper height for android */
  min-height: 0vh !important;
}
</style>